let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bfA3A")).then(() => parcelRequire('c8e9X'));